import Component from './component.vue';

export default Component;



// WEBPACK FOOTER //
// ./src/pages/event/card/button-deferred/index.ts